import { apiGet } from "helpers/Request";
import { useAuth } from "hooks/Auth";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { transform as contentTransformer } from "schemas/Content";

function ContentDescription(props) {
    const [loading, setLoading] = useState(true);
    const [content, setContent] = useState({});
    const auth = useAuth();

    const { uuid } = props;

    useEffect(() => {
        if (!uuid) {
            return;
        }

        setLoading(true);
        apiGet("/v4/content/" + uuid, auth.publication, {
            exclude: "workflow,lock,authors,tags,attachment,metaProperties",
        }).then((res) => {
            setContent(contentTransformer(res));
            setTimeout(() => {
                setLoading(false);
            }, 100);
        });
    }, [uuid, auth.publication]);

    if (loading || !content.uuid) {
        return (
            <div className="animate-pulse rounded bg-gray-300 text-sm text-gray-300">
                Loading...
            </div>
        );
    }
    return (
        <Link className="hover:underline" to={content.edit_url}>
            {content.title}
        </Link>
    );
}

export default ContentDescription;
